<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item
        [innerHTML]="'tkey;admin.proxy_server_management.zpm_connection_settings.about' | escapeHtml"
      ></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-text [fieldId]="'host'"></ziro-text>
      <ziro-text [fieldId]="'secret'"></ziro-text>
    </ziro-collapsible-section-card>

    @if (healthStatusAlertCss) {
      <div class="mt-3 alert" [ngClass]="healthStatusAlertCss" [innerHTML]="healthStatusAlertText | escapeHtml"></div>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
